import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const announcements = [{
  title: 'Picus Security named Innovation Leader for Adversarial Exposure Validation in Gartner Magic Quadrant 2026',
  cta: 'Learn More',
  to: '/company/about'
}, {
  title: 'The 6th Annual Red Report is Live',
  cta: 'Download Now',
  to: '/research/red-report'
}, {
  title: 'Frost and Sullivan picked Picus as the ASV Product of the Year 2026',
  cta: 'Learn More',
  to: '/company/about'
}];
export function HaloBanner() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const goNext = useCallback(() => {
    setDirection(1);
    setIndex(prev => (prev + 1) % announcements.length);
  }, []);
  const goPrev = useCallback(() => {
    setDirection(-1);
    setIndex(prev => (prev - 1 + announcements.length) % announcements.length);
  }, []);
  useEffect(() => {
    const interval = setInterval(goNext, 5000);
    return () => clearInterval(interval);
  }, [goNext]);
  const current = announcements[index];
  const variants = {
    enter: (dir: number) => ({
      opacity: 0,
      y: dir > 0 ? 14 : -14
    }),
    center: {
      opacity: 1,
      y: 0
    },
    exit: (dir: number) => ({
      opacity: 0,
      y: dir > 0 ? -14 : 14
    })
  };
  return <div className="fixed top-0 left-0 right-0 z-[60] bg-picus-accent border-b border-picus-accent" data-id="element-340">
      <div className="max-w-[1536px] mx-auto px-6 h-[52px] flex items-center justify-between overflow-hidden" data-id="element-341">
        {/* Animated title + CTA */}
        <div className="flex-1 flex justify-center items-center gap-4" data-id="element-342">
          <AnimatePresence mode="wait" custom={direction} data-id="element-343">
            <motion.div key={index} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="flex items-center gap-4 min-w-0" data-id="element-344">
              <span className="font-mono text-[16px] leading-[24px] text-white text-center truncate max-w-[800px]" data-id="element-345">
                {current.title}
              </span>
              <Link to={current.to} className="flex-shrink-0 inline-flex items-center gap-2 pb-1 border-b border-white font-mono text-[14px] leading-[16px] font-medium uppercase tracking-[2px] text-white hover:text-black hover:border-black transition-colors whitespace-nowrap" data-id="element-346">
                {current.cta}
                <ChevronRight className="w-3 h-3" data-id="element-347" />
              </Link>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>;
}